"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconSecurity = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Security" }, props),
        react_1.default.createElement("title", null, "Security"),
        react_1.default.createElement("path", { d: "M94.243 61.672H77.12V42.825c0-9.45-7.682-17.132-17.121-17.132-9.44 0-17.121 7.682-17.121 17.132v18.846H25.757V42.826c0-18.89 15.364-34.253 34.243-34.253s34.243 15.364 34.243 34.253v18.846z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M102.857 59.99H17.143v51.428h85.714V59.989z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M102.857 59.99H17.143v25.714h85.714V59.989z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M70.136 76.918c0-5.604-4.543-10.136-10.136-10.136-5.604 0-10.136 4.543-10.136 10.136 0 3.75 2.047 7.018 5.068 8.775V99.3h10.136V85.693c3.032-1.757 5.068-5.025 5.068-8.775z", fill: "#000" })));
};
exports.default = BrandIconSecurity;
